'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../../common/alias/index');

var _index2 = _interopRequireDefault(_index);

var _Alias = require('./Alias');

var _Alias2 = _interopRequireDefault(_Alias);

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        containerComponent: _Alias2.default,
        presentationalComponent: _Alias2.default,
        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ICON],
        showTool: false
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/alias/index.js
// module id = 1951
// module chunks = 0